import slug from 'constants/slug'
import createBreadcrumb from 'shared/breadcrumb/hoc'
//import Icon from 'themes/icon'

export default createBreadcrumb({
  hook: {
    id: 'hook',
    href: slug.hook,
    name: 'Hook'
  }
})



// WEBPACK FOOTER //
// ./src/containers/hook/breadcrumb.js